import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import { isTrialExpired } from '@traaker/shared';
import Sidebar from './Sidebar';
import Header from './Header';
import BillingBanner from './BillingBanner';
import TopupModal from '../billing/TopupModal';
import TrialExpiredOverlay from '../billing/TrialExpiredOverlay';
import { useAuth } from '../../contexts/AuthContext';

const DRAWER_WIDTH = 260;

export default function DashboardLayout() {
  const { tenant } = useAuth();
  // Expired time-bound trial (basic only; agency never expires). Sidebar + header
  // stay sharp + usable; only the content area is blurred behind the paywall, so
  // historical data is teasingly visible but unreadable until they subscribe.
  const trialExpired = tenant ? isTrialExpired(tenant, Date.now()) : false;

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <Sidebar width={DRAWER_WIDTH} />
      <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
        <Header />
        <BillingBanner />
        <Box
          component="main"
          sx={{ flexGrow: 1, p: 3, position: 'relative' }}
        >
          <Box
            sx={
              trialExpired
                ? {
                    filter: 'blur(6px)',
                    pointerEvents: 'none',
                    userSelect: 'none',
                    transition: 'filter 240ms ease',
                  }
                : undefined
            }
            aria-hidden={trialExpired || undefined}
          >
            <Outlet />
          </Box>
          {trialExpired && <TrialExpiredOverlay tier={tenant!.tier} />}
        </Box>
      </Box>
      <TopupModal />
    </Box>
  );
}
